import validator from 'ui-validator';
import context from '../../serverContext';

const borrowerStates = context.borrowerStates;

const checkValidState = validator.createValidator((options, value, key, attributes) => {
  if (
    Array.isArray(borrowerStates) &&
    borrowerStates.length &&
    Object.hasOwnProperty.call(attributes, key) &&
    value !== ''
  ) {
    const thisState = value.toUpperCase();
    const selection = borrowerStates.filter(state => state.stateCode === thisState);

    if (!selection || !selection.length) {
      return 'A valid 2-letter state abbreviation is required';
    }

    const unsupportedStates = borrowerStates.filter(state => !state.eligible);
    const unsupportedStatesCode = unsupportedStates.map(state => state.stateCode);
    const unsupportedStatesName = unsupportedStates.map(state => state.stateName);
    if (unsupportedStatesCode.indexOf(thisState) > -1) {
      return `At this time, we are not accepting loan applications from the following states: ${unsupportedStatesName.join(
        ', '
      )}`;
    }
  }

  return undefined;
});

const v = validator.validators;
const allValidations = {
  streetAddress: {
    required: v.required({ key: 'street address' }),
    inputLength: v.inputLength({ max: 50, key: 'street address' }),
    suspicious: v.suspicious(),
  },
  city: {
    required: v.required(),
    inputLength: v.inputLength({ max: 40 }),
    suspicious: v.suspicious(),
    isAlpha: v.customCondition({ condition: /[0-9]/, message: 'City may only contain letters' }),
    customCondition: v.customCondition({
      message:
        "Please revise your city to ensure that it doesn't include your name, Social Security Number, email address, or other information that could identify where you live. Please do not use any of the following characters: *)",
      condition: /.*(@|(\.com|\.net|\.edu|\.gov|\.org|\.biz)(?![a-z])|\*).*/,
    }),
  },
  state: {
    required: v.required(),
    suspicious: v.suspicious(),
    checkValidState: checkValidState(),
  },
  zip: {
    required: v.required({ key: 'Zip Code' }),
    validZipcode: v.validZipcode(),
    suspicious: v.suspicious(),
  },
};

const validations = fieldName => {
  if (fieldName) {
    return {
      [fieldName]: allValidations[fieldName],
    };
  }
  return allValidations;
};
export default validations;

export const addressValidations = allValidations;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/Address/Address.scss');